import { useWorkflowBuilder } from "./useWorkflowBuilder"

// Reactively reads a workflow group's enabled flag by its canvas id. Used by the box, banner,
// toolbar and cards so they all react to the enable/disable toggle without recomputing the layout.
// Unknown ids resolve to enabled.
export function useWorkflowEnabled(workflowId: string) {
  const { form } = useWorkflowBuilder()
  const index = form.watch("workflows")?.findIndex((workflow) => workflow.id === workflowId) ?? -1
  return index >= 0 ? form.watch(`workflows.${index}.isEnabled`) : true
}
